import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { Reveal, ChapterBadge } from "@/components/Reveal";

export default function Awards() {
  const [awards, setAwards] = useState(null);

  useEffect(() => {
    api.get("/awards").then((r) => setAwards(r.data)).catch(() => setAwards([]));
  }, []);

  if (!awards || awards.length === 0) return null;

  return (
    <section data-testid="awards-section" className="py-20 sm:py-24 border-t border-charcoal-900/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="" label="Recognition" />
        <Reveal className="mt-8 max-w-2xl">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-charcoal-900 leading-[1.1]">
            Awards &amp; <em className="italic text-copper-600">recognition.</em>
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {awards.map((a, i) => (
            <Reveal key={a.id} delay={Math.min(i * 0.06, 0.3)}>
              <div
                data-testid={`award-card-${i}`}
                className="group h-full bg-surface-white border border-charcoal-900/10 rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:border-copper-600/30 transition-[transform,box-shadow,border-color] duration-300"
              >
                {a.image_path ? (
                  <a href={mediaUrl(a.image_path)} target="_blank" rel="noopener noreferrer" className="block aspect-[16/10] overflow-hidden bg-surface-muted">
                    <img
                      src={`${mediaUrl(a.image_thumb_path || a.image_path)}?thumb=1`}
                      alt={a.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </a>
                ) : (
                  <div className="aspect-[16/10] bg-surface-muted flex items-center justify-center">
                    <span className="w-12 h-12 rounded-full bg-copper-100 border border-copper-600/20 flex items-center justify-center text-copper-600">
                      <Award className="w-6 h-6" />
                    </span>
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-charcoal-900 leading-snug">{a.title}</h3>
                  <p className="mt-1.5 font-mono text-xs tracking-[0.15em] uppercase text-charcoal-500">
                    {[a.issuer, a.year].filter(Boolean).join(" · ")}
                  </p>
                  {a.description && (
                    <p className="mt-3 text-sm text-charcoal-600 leading-relaxed">{a.description}</p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
